export const NOTIFICATION_POPUP_DEBOUNCE_MS = 300;
export const NOTIFICATION_BADGE_MAX = 99;

/** Pause after mark-all-as-seen before navigating back (ms). */
export const NOTIFICATION_MARK_ALL_ACK_MS = 2200;

/** Shell morph duration (summary ↔ drill-in). Keep in sync with DialogContent transition. */
export const NOTIFICATION_POPUP_SHELL_MORPH_MS = 320;

/**
 * Shell sizes in rem so they track board `html` font-size (same as Tailwind rem
 * type/spacing inside Updates). Prefer a larger shell over shrinking mosaic type.
 * Baseline: 48.75rem×32.5rem ≈ 780×520 at 16px root; 73.75rem×56.25rem ≈ 1180×900.
 */
export const NOTIFICATION_POPUP_SUMMARY_SIZE = {
  width: "min(48.75rem, 94vw)",
  maxWidth: "48.75rem",
  height: "min(90vh, 32.5rem)",
  maxHeight: "min(90vh, 32.5rem)",
} as const;

/** Drill-in shell size (Notable / category / Ask). Routine browse uses this when >4 category tiles. */
export const NOTIFICATION_POPUP_EXPANDED_SIZE = {
  width: "min(73.75rem, 96vw)",
  maxWidth: "73.75rem",
  height: "min(85vh, 56.25rem)",
  maxHeight: "min(85vh, 56.25rem)",
} as const;

/**
 * Routine category browse: use expanded shell when visible category tiles
 * exceed this count; otherwise keep summary size.
 */
export const ROUTINE_SHELL_EXPANDED_AFTER_CATEGORY_COUNT = 4;

/** Mosaic motion — no hover lift per jony-swiv law; active scale only. */
export const NOTIFICATION_TILE_MOTION_CLS =
  "transition-[transform] duration-150 ease-out motion-safe:active:scale-[0.98]";

/** Shared chrome fill — solid muted + input border so controls read on bg-background. */
export const SURFACE_CONTROL_CLS =
  "border border-input bg-muted text-foreground/80 shadow-sm";

/** Shared chrome controls for the notification popup. */
export const SURFACE_ICON_BTN_CLS =
  `size-9 shrink-0 rounded-full ${SURFACE_CONTROL_CLS} transition-[transform,background-color,color,border-color] duration-150 ease-out hover:border-input-enhanced hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:scale-[0.97] motion-reduce:active:scale-100`;

export const SURFACE_ICON_GLYPH_CLS = "size-4";

export const SURFACE_BACK_BTN_CLS =
  `inline-flex h-9 items-center gap-1.5 rounded-full ${SURFACE_CONTROL_CLS} px-3.5 text-sm font-medium transition-[transform,background-color,color,border-color] duration-150 ease-out hover:border-input-enhanced hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring active:scale-[0.98] motion-reduce:active:scale-100`;

export const SURFACE_SEARCH_CLS =
  `flex h-9 w-full rounded-full ${SURFACE_CONTROL_CLS} pl-9 pr-9 text-sm outline-none transition-[border-color,background-color] duration-150 ease-out placeholder:text-sm placeholder:text-muted-foreground hover:border-input-enhanced focus-visible:border-input-enhanced focus-visible:bg-background focus-visible:text-foreground`;
